<template>
  <div class="loading-box">
    <div class="loading-center">
      <img src="https://cdn.geement.com/sfiles/PrivateMallUniapp/loading_bg.png" alt="" class="loading_bg">
      <!-- <img src="https://cdn.geement.com/sfiles/BaiShiKeLe/tianjin_acth5_2024/loading_logo.png" alt="" class="loading_logo"> -->
      <!-- <p>上传中...</p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      point: [1], // 点的数组
      timer: '', // 定时器
    }
  },

  created() {
    
  },

  beforeDestroy() {
    
  }
}
</script>

<style lang="scss" scoped>
.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(#000, .2);
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 11.6rem;
  z-index: 2010;

  .loading-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5rem;
    height: 5rem;
    margin-bottom: 8.5rem;
    
    .loading_bg{
        width: 5rem;
        height: 5rem;
        animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    
    .loading_logo{
        width: 5.2rem;
        height: 5.2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    p {
      font-size: .7rem;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: .7rem;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue